import { render, staticRenderFns } from "./mo-clazz-chart.vue?vue&type=template&id=205b683d&scoped=true&"
import script from "./mo-clazz-chart.vue?vue&type=script&lang=js&"
export * from "./mo-clazz-chart.vue?vue&type=script&lang=js&"
import style0 from "./mo-clazz-chart.vue?vue&type=style&index=0&id=205b683d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205b683d",
  null
  
)

export default component.exports